// packages/shared/src/utils/getEnv.js
import { getRuntimeEnvVar } from '../config/runtimeEnv';

let _getEnvVarImpl = null;

/**
 * App sets this once at startup (web/notes/mobile).
 */
export function setGetEnvVarImpl(fn) {
  _getEnvVarImpl = typeof fn === 'function' ? fn : null;
}

/**
 * Shared code calls this. It delegates to the app-provided implementation.
 */
export function getEnvVar(name) {
  // Web (CRA/Vite style)
  if (typeof document !== 'undefined') {
    //return process.env[`REACT_APP_${name}`];
    return getRuntimeEnvVar(name);
  }

  // Expo / React Native
  return process.env.EXPO_PUBLIC_API_URL;
}
